import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ChangeDetectionStrategy,
  input,
  output,
  viewChild,
} from '@angular/core';
import { fromEvent, map, merge, Observable, ReplaySubject } from 'rxjs';
import { VideoActions } from '../models/video-actions';

@Component({
  selector: 'app-video-player',
  standalone: true,
  imports: [],
  templateUrl: './video-player.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './video-player.component.scss',
})
export class VideoPlayerComponent implements OnInit, AfterViewInit {
  readonly pause = input.required<Observable<void>>();
  readonly play = input.required<Observable<void>>();
  readonly videoPath = input.required<string | undefined>();

  readonly videoEnd = output<any>();

  readonly videoPlayer = viewChild.required<ElementRef<HTMLVideoElement>>('videoElement');

  private _videoActions = new ReplaySubject<VideoActions>(1);

  ngAfterViewInit(): void {
    fromEvent(this.videoPlayer()?.nativeElement, 'ended').subscribe((v) => this.videoEnd.emit(v));
    this._videoActions.subscribe((action) => {
      const videoPlayer = this.videoPlayer();
      if (videoPlayer) {
        switch (action) {
          case 'PLAY':
            videoPlayer.nativeElement.pause();
            videoPlayer.nativeElement.load();
            videoPlayer.nativeElement.currentTime = 0;
            videoPlayer.nativeElement.play();
            break;
          case 'PAUSE':
            videoPlayer.nativeElement.pause();
            break;
        }
      }
    });
  }

  ngOnInit(): void {
    merge(this.play().pipe(map(() => 'PLAY')), this.pause().pipe(map(() => 'PAUSE'))).subscribe((action) => {
      this._videoActions.next(action as VideoActions);
    });
  }
}
